/// <reference types="vite/client" />
import { AppEnvironment } from "./constants";

export const getEnvVar = (key: string): string | undefined => {
  // Vite browser context
  if (typeof import.meta !== "undefined" && import.meta.env) {
    return import.meta.env[key];
  }
  // Node.js context (SSG build)
  if (typeof process !== "undefined" && process.env) {
    return process.env[key];
  }
  return undefined;
};

export const isDevMode = (): { isDev: boolean; reason: string } => {
  const explicitEnv = getEnvVar("VITE_ENVIRONMENT");
  if (explicitEnv) {
    if (explicitEnv === AppEnvironment.DEVELOPMENT) {
      return {
        isDev: true,
        reason: `VITE_ENVIRONMENT=${explicitEnv} (environment variable)`,
      };
    }
    return {
      isDev: false,
      reason: `VITE_ENVIRONMENT=${explicitEnv} (not development)`,
    };
  }
  // Vite's DEV flag
  if (typeof import.meta !== "undefined" && import.meta.env?.DEV) {
    return { isDev: true, reason: "import.meta.env.DEV=true (Vite dev mode)" };
  }
  // Node.js NODE_ENV
  if (
    typeof process !== "undefined" &&
    process.env?.NODE_ENV === "development"
  ) {
    return { isDev: true, reason: "NODE_ENV=development (Node.js)" };
  }
  // No explicit env set; default to non-development.
  return { isDev: false, reason: "No development mode triggers detected" };
};

export const getApiBaseUrl = (): string => {
  const url = getEnvVar("VITE_API_BASE_URL");
  if (url) {
    return url;
  }
  return isDevMode().isDev
    ? "http://localhost:8788/api/backend"
    : "/api/backend";
};

/**
 * Get the absolute backend origin used for websocket or direct backend connections.
 */
export const getBackendOrigin = (): string => {
  const envUrl = getEnvVar("VITE_BACKEND_ORIGIN");
  if (envUrl) {
    return envUrl;
  }
  const apiBaseUrl = getEnvVar("VITE_API_BASE_URL");
  if (apiBaseUrl && /^https?:\/\//i.test(apiBaseUrl)) {
    return apiBaseUrl;
  }
  return "https://platform.ayla-ai.com";
};

const TURNSTILE_DEVELOPMENT_SITE_KEY = "1x00000000000000000000AA";
const TURNSTILE_PRODUCTION_SITE_KEY = "0x4AAAAAABDgIDKdiTLiwwWk";

export const getTurnstileSiteKey = (): string => {
  const siteKey = getEnvVar("VITE_TURNSTILE_SITE_KEY");
  if (siteKey) {
    return siteKey;
  }

  return isDevMode().isDev
    ? TURNSTILE_DEVELOPMENT_SITE_KEY
    : TURNSTILE_PRODUCTION_SITE_KEY;
};
